import { clearFilterParams, useCleanFilterForRequest } from '@btime/react-contexts'
import { gql } from '@apollo/client'
import { mergeDeepLeft, path } from 'ramda'
import React from 'react'

import { serviceOrdersClient } from '../../utils/apollo/api'
import { usePromiseQuery } from '../../utils/apollo/_helpers/promiseQuery'
import LazySelectAllLinkApollo from '../../components/actions/LazySelectAllLinkApollo'

const QUERY = gql`
  query ServiceOrders($search: String, $filter: ServiceOrderFilter) {
    serviceOrders(limit: 900000, search: $search, filter: $filter) {
      id
    }
  }
`

export const useGetAllServiceOrders = propFilters => {
  const filter = mergeDeepLeft(clearFilterParams(propFilters || []) || {}, useCleanFilterForRequest() || {})
  const call = usePromiseQuery(QUERY, {
    variables: { filter },
    client: serviceOrdersClient
  })
  return () => call().then(path(['data', 'serviceOrders']))
}

//TODO: Use useGetAllServiceOrders func
const SelectAllServiceOrdersLink = ({ search, filter, ...props }) => {
  return (
    <LazySelectAllLinkApollo
      query={QUERY}
      variables={{ search, filter: clearFilterParams(filter || {}) }}
      client={serviceOrdersClient}
      {...props}
    />
  )
}

export default SelectAllServiceOrdersLink
